<!-- reCAPTCHA with invisible mode -->
<div class="captcha-container" *ngIf="showCaptcha">
  <div class="captcha-explanation text-muted font-size-secondary mb-2">
    <app-icon icon="fa fa-shield-alt mr-1"></app-icon>
    <span>{{ 'public.checkout.captcha.explanation' | translate }}</span>
  </div>

  <!-- ReCAPTCHA Component -->
  <re-captcha
    #captchaRef="reCaptcha"
    [siteKey]="siteKey"
    (resolved)="resolved($event)"
    (errored)="errored($event)"
    (expired)="expired()"
    errorMode="handled"
    size="invisible"
  ></re-captcha>

  <!-- Loading indicator - shown while verifying -->
  <div
    class="captcha-status d-flex align-items-center text-info font-size-secondary mb-2"
    *ngIf="isLoading"
  >
    <div class="spinner-border spinner-border-sm mr-2" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <span>{{ 'public.checkout.captcha.verifying' | translate }}</span>
  </div>

  <!-- Success message - shown after verification -->
  <div
    class="captcha-success alert alert-success mb-2"
    *ngIf="captchaToken && !isLoading && !errorMessage"
  >
    <app-icon icon="fa fa-check-circle mr-2"></app-icon>
    <span>{{ 'public.checkout.captcha.verified' | translate }}</span>
  </div>

  <!-- Error message - shown only if verification fails AND no verification is currently in flight -->
  <div
    class="captcha-error alert alert-danger mb-2"
    *ngIf="errorMessage && !isLoading"
  >
    <app-icon icon="fa fa-exclamation-triangle mr-2"></app-icon>
    <span class="error-text">{{ errorMessage | translate }}</span>
  </div>
</div>
